(function() {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('PendenciasRelatorioEleitoralService', PendenciasRelatorioEleitoralService);

  function PendenciasRelatorioEleitoralService($http, ngsalConfig) {

    var service = {
      listarPendencias: listarPendencias
    };

    return service;

    function listarPendencias(periodo) {

      var promise = $http.get(`/mgp-corregedoria/api/${ngsalConfig.apiVersion}/relatorio/eleitoral/pendencias/${periodo}`)
        .then((response) => {
          return response.data;
        });

      return promise;
    }
  }

})();